<template>
    <div class="card-container">
        <div class="bg-white rounded-lgr shadow-[2px_2px_10px_0px_rgba(0,0,0,0.1)] border border-valence-grey-250 flex gap-2.5 p-5 h-full card">
            <div class="text-[#595959] body-small-semibold">Will you be completing this {{ momentTitle }} for other team members?</div>
            <div class="flex gap-5 h-full flex-1 justify-end card-button-container">
                <div class="flex flex-row gap-4">
                    <label class="flex items-center gap-2 cursor-pointer" for="review-conductor-yes">
                        <input
                            id="review-conductor-yes"
                            v-model="selectedValue"
                            type="radio"
                            name="review-conductor"
                            value="yes"
                            class="w-4 h-4 border-gray-300 focus:ring-[#595959] accent-black" />
                        <span class="body-small-semibold text-[#595959]">Yes</span>
                    </label>
                    <label class="flex items-center gap-2 cursor-pointer" for="review-conductor-no">
                        <input
                            id="review-conductor-no"
                            v-model="selectedValue"
                            type="radio"
                            name="review-conductor"
                            value="no"
                            class="w-4 h-4 border-gray-300 focus:ring-[#595959] accent-black" />
                        <span class="body-small-semibold text-[#595959]">No</span>
                    </label>
                </div>
                <button
                    type="button"
                    class="bg-valence-primary-200 rounded-3xl px-4 py-2 hover:bg-[#B8B9FF] disabled:bg-valence-grey-250 disabled:text-[#bfbfbf] body-semibold"
                    :disabled="!selectedValue"
                    @click="handleConfirm">
                    Confirm
                </button>
            </div>
        </div>
        <BaseToast v-model:open="isErrorToastOpen" theme="error" :description="errorMessage" />
    </div>
</template>

<script setup lang="ts">
import { router } from "@inertiajs/vue3";
import { useFetch } from "~vue/api";
import BaseToast from "~vue/components/BaseToast.vue";
import { logUserInteraction } from "~vue/utils/logUtils";
import { computed, onMounted, ref } from "vue";

import { PERFORMANCE_REVIEW_EVENT_PREFIX } from "./constants";

const props = withDefaults(
    defineProps<{
        momentId?: string | number | null;
        momentTitle?: string | null;
    }>(),
    { momentId: null, momentTitle: "" },
);

const selectedValue = ref(null);

const { execute: sendReviewSelection, error: sendReviewSelectionError } = useFetch("/api/coach/performance_reviews/user_data/", { immediate: false })
    .post(
        computed(() => ({
            has_people_to_review: selectedValue.value === "yes",
        })),
    )
    .json();

const isErrorToastOpen = ref(false);
const errorMessage = ref("");

const handleConfirm = async () => {
    // execute() resolves even on HTTP errors, exposing them via the error ref instead of throwing.
    await sendReviewSelection();
    if (sendReviewSelectionError.value) {
        errorMessage.value = "Failed to submit your selection. Please try again.";
        isErrorToastOpen.value = true;
        return;
    }

    logUserInteraction(`${PERFORMANCE_REVIEW_EVENT_PREFIX}has_people_to_review_selected`, {
        has_people_to_review: selectedValue.value === "yes",
        moment_id: props.momentId,
    });
    router.reload({ only: ["has_people_to_review"] });
};

onMounted(() => logUserInteraction(`${PERFORMANCE_REVIEW_EVENT_PREFIX}has_people_to_review_question_presented`));
</script>

<style scoped>
.card-container {
    container-type: inline-size;
    width: 100%;
}

.card,
.card-button-container {
    flex-direction: column;
    align-items: flex-start;
}
@container (min-width: 600px) {
    .card,
    .card-button-container {
        align-items: center;
        flex-direction: row;
    }
}
</style>
